import { render, staticRenderFns } from "./addrTable.vue?vue&type=template&id=62563bd0"
import script from "./addrTable.vue?vue&type=script&lang=js"
export * from "./addrTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports